import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import Tabs from "design/components/toolbar/Tabs";
import PeriodSelector from "components/PeriodSelector";
import SplitView from "design/layouts/SplitView";
import Center from "design/layouts/Center";
import Right from "design/layouts/Right";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import ToolbarTitle from "design/components/texts/ToolbarTitle";

const ReportsToolbar = (props: { selected?: string }) => {
  const ctx = useAppContext();
  const link = useLink();
  return (
    <ToolbarContainer>
      <SplitView partCnt={3}>
        <ToolbarTitle>
          {ctx.page === "reporttemplates"
            ? "Report Templates"
            : "Configurable Reports"}
        </ToolbarTitle>
        <Center>
          <Tabs
            onChange={(value) => {
              link({
                page: value,
              });
            }}
            selected={props.selected || ctx.page || ""}
            options={[
              {
                viewName: "reporttemplates",
                title: "Report Templates",
              },
              {
                viewName: "configurablereports",
                title: "Configurable Reports",
              },
            ]}
          />
        </Center>
      </SplitView>
    </ToolbarContainer>
  );
};

export default ReportsToolbar;
